import { Type } from '@angular/core';
import {LabelComponent} from "./label.component";

export const LABEL_DIRECTIVES: Type<any>[] = [
  LabelComponent
];
